import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import "./Navbar.css";

export default function Navbar() {
  return (
    <header className="navbar">
      
      <div className="logo">
        <img src={logo} alt="Neva Logo" className="logo-img" />
    
      </div>

      <nav>
        <Link to="/">Ana Sayfa</Link>
        <Link to="hakkimizda">Hakkımızda</Link>
        <Link to="/projeler">Projeler</Link>
        <Link to="/iletisim">İletişim</Link>

       <Link to="/iletisim">
  <button>Teklif Al</button>
</Link>
      </nav>

    </header>
  );
}